import { useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";

// IMPORT DES STEPS (tu les créeras après)
import BasicInfoStep from "./steps/BasicInfoStep";
import PhotosStep from "./steps/PhotosStep";
import PricingStep from "./steps/PricingStep";
import EquipmentsStep from "./steps/EquipmentsStep";
import PmsStep from "./steps/PmsStep";
import ReviewStep from "./steps/ReviewStep"


const steps = [
  "Informations",
  "Photos",
  "Prix",
  "Équipements",
  "Validation"
];

export default function CreateHotel() {
  const [currentStep, setCurrentStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { userId } = useParams();

  const [formData, setFormData] = useState({
    name: "",
    type: "",
    island: "",
    city: "",
    adress: "",
    desc: "",
    cheapestPrice: "",
    photos: [],
    equipments: [],
    pms: null
  });

  // NAVIGATION
  const next = () => setCurrentStep((prev) => prev + 1);
  const prev = () => setCurrentStep((prev) => prev - 1);

  // VALIDATION SIMPLE
  const canGoNext = () => {
    if (currentStep === 0) {
      return (
        formData.name &&
        formData.type &&
        formData.island &&
        formData.city &&
        formData.adress 
      );
    }

    if (currentStep === 2) {
      return formData.cheapestPrice > 0;
    }

    return true;
  };

const handleSubmit = async () => {
  try {
    setLoading(true);


    const payload = {
        name: formData.name,
        type: formData.type,
        island: formData.island,
        city: formData.city,
        adress: formData.adress,
        desc: formData.desc,
        cheapestPrice: Number(formData.cheapestPrice) || 0,
        photos: formData.photos.map(p => p.url), // 🔥 FIX
        equipments: formData.equipments,
        pms: formData.pms
    };

    const res = await axios.post(
      `https://api.komorotel.com/api/hotels`, 
      payload,
      {
        withCredentials: true,

      }
    );

    const hotelId = res.data._id;

    // 🔥 REDIRECT CLEAN
    toast.success("Hôtel créé avec succès 🎉");
    navigate(`/admin/${userId}/${hotelId}`);

  } catch (err) {
    console.error(err.response?.data || err.message);
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4">
      <div className="max-w-5xl mx-auto">

        {/* CARD */}
        <div className="bg-white rounded-3xl shadow-lg p-8">

          {/* HEADER */}
          <div className="mb-8">
            <h1 className="text-3xl font-semibold">
              Créer un établissement
            </h1>
            <p className="text-gray-500 mt-1">
              Ajoutez votre hôtel en quelques étapes
            </p>
          </div>

          {/* STEPPER */}
          <div className="flex items-center justify-between mb-10">
            {steps.map((step, index) => (
              <div key={index} className="flex-1 flex items-center">

                {/* BULLE */}
                <div
                  className={`w-8 h-8 flex items-center justify-center rounded-full text-sm font-semibold
                  ${
                    index <= currentStep
                      ? "bg-green-600 text-white"
                      : "bg-gray-200 text-gray-500"
                  }`}
                >
                  {index + 1}
                </div>

                {/* BARRE */}
                {index < steps.length - 1 && (
                  <div
                    className={`flex-1 h-1 mx-2
                    ${
                      index < currentStep
                        ? "bg-green-600"
                        : "bg-gray-200"
                    }`}
                  />
                )}
              </div>
            ))}
          </div>

          {/* CONTENU */}
          <div className="min-h-[300px]">

            {currentStep === 0 && (
              <BasicInfoStep
                formData={formData}
                setFormData={setFormData}
              />
            )}

            {currentStep === 1 && (
              <PhotosStep
                formData={formData}
                setFormData={setFormData}
              />
            )}

            {currentStep === 2 && (
              <PricingStep
                formData={formData}
                setFormData={setFormData}
              />
            )}

            {currentStep === 3 && (
              <EquipmentsStep
                formData={formData}
                setFormData={setFormData}
              />
            )}


            {currentStep === 4 && (
              <ReviewStep formData={formData} />
            )}

          </div>

          {/* NAVIGATION */}
          <div className="flex justify-between mt-10">

            {/* BACK */}
            {currentStep > 0 ? (
              <button
                onClick={prev}
                className="px-5 py-2.5 rounded-xl bg-gray-100 hover:bg-gray-200 transition"
              >
                Retour
              </button>
            ) : (
              <div />
            )}

            {/* NEXT / SUBMIT */}
            {currentStep < steps.length - 1 ? (
              <button
                onClick={next}
                disabled={!canGoNext()}
                className={`px-6 py-3 rounded-xl font-medium transition
                  ${
                    canGoNext()
                      ? "bg-green-600 text-white hover:bg-green-700"
                      : "bg-gray-300 text-gray-500 cursor-not-allowed"
                  }`}
              >
                Suivant
              </button>
            ) : (
              <button
                onClick={handleSubmit}
                disabled={loading}
                className="px-6 py-3 bg-black text-white rounded-xl hover:bg-gray-800 transition"
                >
                {loading ? "Création..." : "Créer l'hôtel"}
                </button>
            )}

          </div>

        </div>
      </div>
    </div>
  );
}